/// <reference lib="dom" />
/** @jsx h */
import { h } from "preact";
import { useEffect } from "preact/hooks";
import * as d3 from "d3";
import { CreateChart } from "../../core/chart.ts";
import { InlineSize, ModeTheme, PadMargin } from "../../core/mode.ts";
import { useChart } from "../../core/useChart.ts";
import { RefLineLayer } from "../../layers/refLine.ts";
import { HandlesLayer } from "../../layers/handles.ts";
import { ChartPalette } from "../../utils/theme.ts";

export const PannerInlineSize = { ...InlineSize, pad: 4 };

function CreatePannerChart(container: HTMLElement) {
  const dot = HandlesLayer({ id: "pan" });
  const chart = CreateChart(container, {
    height: PannerInlineSize.height,
    margin: PadMargin(PannerInlineSize.pad),
    x: d3.scaleLinear().domain([-1, 1]),
    y: d3.scaleLinear().domain([-1, 1]),
    theme: ModeTheme("inline"),
    layers: [
      RefLineLayer({ axis: "y", value: 0, dashed: false }),
      RefLineLayer({ axis: "x", value: 0, dashed: false }),
      dot,
    ],
  });
  return { chart, dot, destroy: chart.destroy };
}

export interface PannerGraphProps {
  pan: number;
  color?: string;
}

export function PannerGraph(props: PannerGraphProps) {
  const { ref, chart } = useChart(CreatePannerChart, []);
  const color = props.color ?? ChartPalette.green;
  useEffect(() => {
    if (!chart) return;
    chart.dot.set([{ id: "pan", x: props.pan, y: 0, radius: 3, filled: true, color }]);
    chart.chart.render();
  }, [chart, props.pan, color]);
  return <div ref={ref} />;
}
